import { useState } from 'react';
import { Document, Page } from 'react-pdf';
import ControlPanel from '../../../../../../components/ControlPanel';

export const CoPreviewContract = () => {
  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [scale, setScale] = useState(1.5);
  const [docToSign] = useState('/assets/pdf/contract.pdf');

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  return (
    <div className="flex flex-col max-h-full overflow-hidden justify-between  ">
      {docToSign && (
        <div>
          <section id="pdf-section" className="flex flex-col align-items-center d-flex overflow-auto">
            <ControlPanel
              scale={scale}
              setScale={setScale}
              numPages={numPages}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              file={docToSign}
            />
            <div className="max-h-[70vh] overflow-y-auto max-w-[100vh] flex ">
              <Document file={docToSign} onLoadSuccess={onDocumentLoadSuccess}>
                <Page
                  className={''}
                  pageNumber={pageNumber}
                  scale={scale}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              </Document>
            </div>
          </section>
        </div>
      )}
    </div>
  );
};
